import React from 'react';

import { flagStyles } from '../settings';

const SvgTK = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-5208px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgTK;
